import { render, staticRenderFns } from "./UpdateCommissionContent.vue?vue&type=template&id=553f5c84"
import script from "./UpdateCommissionContent.vue?vue&type=script&lang=js"
export * from "./UpdateCommissionContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports